var _path, _circle, _circle2, _circle3, _circle4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 76,
    viewBox: "0 0 74 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2686 56.6368C49.758 57.8945 57.5391 51.0391 54.1262 43.1648C53.2983 41.2546 52.3218 39.5538 51.2079 38.2336C47.2544 33.5479 41.8922 30.9155 36.3011 30.9155C30.71 30.9155 25.3478 33.5479 21.3943 38.2336C20.2803 39.5538 19.3039 41.2546 18.476 43.1648C15.0631 51.0391 22.8442 57.8945 31.3336 56.6368L34.2415 56.206C35.6071 56.0037 36.9951 56.0037 38.3607 56.206L41.2686 56.6368Z",
    stroke: "white",
    strokeWidth: 3.51356
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.3847,
    cy: 30.9169,
    r: 3.51356,
    stroke: "white",
    strokeWidth: 2.81085
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0897,
    cy: 22.1326,
    r: 5.27034,
    stroke: "white",
    strokeWidth: 3.51356
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2245,
    cy: 30.9169,
    r: 3.51356,
    stroke: "white",
    strokeWidth: 2.81085
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5203,
    cy: 22.1326,
    r: 5.27034,
    stroke: "white",
    strokeWidth: 3.51356
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2308 2.92308C6.19484 2.92308 2.92308 6.19485 2.92308 10.2308V17.1731C2.92308 17.9803 2.26872 18.6346 1.46154 18.6346C0.654353 18.6346 0 17.9803 0 17.1731V10.2308C0 4.58048 4.58047 0 10.2308 0H16.8077C17.6149 0 18.2692 0.654353 18.2692 1.46154C18.2692 2.26872 17.6149 2.92308 16.8077 2.92308H10.2308ZM54.8077 1.46154C54.8077 0.654353 55.462 0 56.2692 0H62.8461C68.4964 0 73.0769 4.58047 73.0769 10.2308V17.1731C73.0769 17.9803 72.4226 18.6346 71.6154 18.6346C70.8082 18.6346 70.1538 17.9803 70.1538 17.1731V10.2308C70.1538 6.19484 66.8821 2.92308 62.8461 2.92308H56.2692C55.462 2.92308 54.8077 2.26872 54.8077 1.46154ZM71.6154 57.3654C72.4226 57.3654 73.0769 58.0197 73.0769 58.8269V65.7692C73.0769 71.4195 68.4965 76 62.8462 76H56.2692C55.462 76 54.8077 75.3456 54.8077 74.5385C54.8077 73.7313 55.462 73.0769 56.2692 73.0769H62.8462C66.8821 73.0769 70.1538 69.8052 70.1538 65.7692V58.8269C70.1538 58.0197 70.8082 57.3654 71.6154 57.3654ZM1.46154 57.3654C2.26872 57.3654 2.92308 58.0197 2.92308 58.8269V65.7692C2.92308 69.8052 6.19485 73.0769 10.2308 73.0769H16.8077C17.6149 73.0769 18.2692 73.7313 18.2692 74.5385C18.2692 75.3456 17.6149 76 16.8077 76H10.2308C4.58048 76 0 71.4195 0 65.7692V58.8269C0 58.0197 0.654353 57.3654 1.46154 57.3654Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeticon);
export default __webpack_public_path__ + "static/media/peticon.f86c49d610d0c6134bf822c25aa80f50.svg";
export { ForwardRef as ReactComponent };